import { ExpandoDirection, ExpandoWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '~src/style';

import { Messages } from '../../codegen/Localize';
import { numberMargin, numberWidth } from './LinkedTaskItem';


const rootClass: string = 'LinkedTaskItemOptionsBar';
const flexStyle: string = '1 1 auto';
const LinkedTaskItemOptionsBarContainerStyle = cssClass(rootClass, 'Container', {
  display: 'flex',
  flex: flexStyle
});

const LinkedTaskItemOptionsBarExpandoStyle = cssClass(rootClass, 'Expando', {
  flex: flexStyle,
  padding: `1px 0px 1px 7px`,
  border: `1px solid ${TabStyles.Colors.L6}`
});

const flowNameStyle = cssClass(rootClass, 'RunflowText', {
  fontWeight: 'bolder',
  paddingLeft: TabStyles.Spacing.DefaultSpace,
});

const LinkedTaskItemOptionsBarExpandedContentStyle = cssClass(rootClass, 'ExpandedContent', {
  padding: TabStyles.Spacing.DefaultSpace,
  marginLeft: numberWidth + numberMargin,
  marginTop: -1,
});

export const OPTIONS_PANE_TEST_ID = 'linked-task-options-content';

export type LinkedTaskItemOptionsBarProps = {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  flowName: string;
  expansionContent: React.ReactNode;
}

export function LinkedTaskItemOptionsBar(props: LinkedTaskItemOptionsBarProps): JSX.Element {
  const labelText = <div>{Messages.linkedTasksRunFlowSentenceCasing()}<span className={flowNameStyle}>{props.flowName}</span></div>;
  return (
    <div className={LinkedTaskItemOptionsBarContainerStyle}>
      <ExpandoWidget
        alignment={'right'}
        direction={ExpandoDirection.Down}
        isExpanded={props.isExpanded}
        label={labelText}
        onCollapse={() => props.setIsExpanded(false)}
        onExpand={() => props.setIsExpanded(true)}
        testId='linked-task-item-options-bar'
        className={LinkedTaskItemOptionsBarExpandoStyle}
      >
        {props.isExpanded && props.expansionContent &&
          <div className={LinkedTaskItemOptionsBarExpandedContentStyle} data-tb-test-id={OPTIONS_PANE_TEST_ID}>
            {props.expansionContent}
          </div>
        }
      </ExpandoWidget>
    </div>);
}